import React from "react";
import { observer } from "mobx-react";
import DatePicker from "shared/AriaDatePicker";
import Loader from "shared/Loader/Loader";
import Icon from "shared/Icon";
import TrendChart from "shared/DiscretesAndTrends/TrendChart";
import { MonitorContext } from "../../Monitor";
import "./TrendCharts.scss";

export default observer(function TrendCharts({
  trendStore,
  colorScheme,
  updateTime,
}) {
  const monitorStore = React.useContext(MonitorContext).store;
  const charts = trendStore.getActiveTrendCharts(monitorStore.discretes);
  if (!charts.length) return null;
  return (
    <div className="trend-charts">
      {trendStore.dataRangeInHours > 24 ? (
        <DatePicker
          dateField={{
            onChange: (date) => trendStore.setStartTime(date),
            value: trendStore.date,
            "aria-label": "trend date",
            minValue: trendStore.minDay,
            maxValue: trendStore.maxDay,
          }}
          input={{
            style: { display: trendStore.isToday ? "none" : undefined },
          }}
          label={trendStore.isToday ? "Past 24 Hours" : undefined}
          step={trendStore.step}
          backDisabled={trendStore.backDisabled}
          forwardDisabled={trendStore.forwardDisabled}
        />
      ) : (
        <div className="date-picker-placeholder">Past 24 Hours</div>
      )}

      {charts.map((chart) => (
        <div
          className={`chart ${chart.title
            .toLowerCase()
            .replace(/[^\w]/g, "-")}`}
          key={chart.title}
        >
          <Icon symbol="x" onClick={() => trendStore.toggleTrendChart(chart)} />
          <div className="chart-title">{chart.title}</div>
          {trendStore.isTrendLoading(chart) ? (
            <Loader size="trend-chart" />
          ) : (
            <TrendChart
              trend={chart.trend}
              color={chart.schemeColors[colorScheme]}
              updateTime={updateTime}
            />
          )}
        </div>
      ))}
    </div>
  );
});
